// extracted by mini-css-extract-plugin
export default {"tr":"Tr_tr__EaFJp","button":"Tr_button__QVNsp"};